import antes1 from "../../assets/Servicos/Antes1.jpeg";
import depois1 from "../../assets/Servicos/Depois1.jpeg";
import antes2 from "../../assets/Servicos/Antes2.jpeg";
import depois2 from "../../assets/Servicos/Depois2.jpeg";
import antes3 from "../../assets/Servicos/Antes3.jpeg";
import depois3 from "../../assets/Servicos/Depois3.jpeg";
import antes4 from "../../assets/Servicos/Antes4.jpeg";
import depois4 from "../../assets/Servicos/Depois4.jpeg";
import antes5 from "../../assets/Servicos/Antes5.jpeg";
import depois5 from "../../assets/Servicos/Depois5.jpeg";

export const beforeAfterItems = [
  {
    id: 1,
    before: antes1,
    after: depois1,
    title: "Transformação 1",
  },
  {
    id: 2,
    before: antes2,
    after: depois2,
    title: "Transformação 2",
  },
  {
    id: 3,
    before: antes3,
    after: depois3,
    title: "Transformação 3",
  },
  {
    id: 4,
    before: antes4,
    after: depois4,
    title: "Transformação 4",
  },
  {
    id: 5,
    before: antes5,
    after: depois5,
    title: "Transformação 5",
  },
];
